<div
  class="alberta-button-input-wrapper"
  [ngClass]="{
    'alberta-button-input-wrapper--alert': ngControl && ngControl.invalid,
    'alberta-button-input-wrapper--disabled': disabled
  }"
  tappable
>
  <div class="button-content-wrapper" (click)="openTimePicker()">
    <div
      class="icon-wrapper"
      *ngIf="!noIcon"
      [ngClass]="{
        'icon-wrapper--stdIcon': !icon
      }"
    >
      <ion-icon [name]="icon ? icon : 'alberta-dot'"></ion-icon>
    </div>
    <div class="content-wrapper">
      <div class="content">
        <div class="inputs-wrapper bold">
          <div class="time-wrapper time-wrapper--only-time" [style.display]="type !== 1 ? 'unset' : 'none'">
            <input
              #timeInput
              [ngxTimepicker]="picker"
              [format]="24"
              [value]="date | date : 'HH:mm'"
              class="time-input"
              [min]="minTime"
              [max]="maxTime"
              readonly
            />
            <ngx-material-timepicker
              #picker
              (timeSet)="setTime($event)"
              [theme]="albertaTimePickerOptions"
              [minutesGap]="5"
              [cancelBtnTmpl]="cancelBtn"
              [confirmBtnTmpl]="confirmBtn"
            ></ngx-material-timepicker>
            <ng-template #cancelBtn>
              <button class="timepickerBtn">{{ 'CANCEL_BUTTON' | translate }}</button>
            </ng-template>
            <ng-template #confirmBtn>
              <button class="timepickerBtn">{{ 'DONE_BUTTON' | translate }}</button>
            </ng-template>
          </div>
        </div>
        <div
          class="deleteButton"
          (click)="removeInput($event)"
          *ngIf="date != undefined && !disabled && !noDeleteButton"
        >
          <ion-icon name="alberta-delete"></ion-icon>
        </div>
      </div>
      <div class="title">{{ title }} <span *ngIf="required" class="required-star">*</span></div>
    </div>
  </div>
  <div class="description" *ngIf="description">
    {{ description }}
  </div>
  <itl-error-display *ngIf="ngControl" [control]="ngControl"></itl-error-display>
</div>
